import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['group_id', 'ID'],
]);

export default function GROUP_SHARE_FILTER_OPTIONS() {
  return gql`
    query GroupShareFilterOptions(${parametersTypeString}) {
      groupShareFilterOptions(${parametersAssignString}) {
        ${defaultResponse}
        data {
          type
          label
          values {
            key
            doc_count
          }
        }
      }
    }
  `;
}
